@include host-component-properties;

:host {
  --paf-toggle-radio-background-color: var(--paf-global-post-brand-white);
  --paf-toggle-radio-background-color-selected: var(--paf-global-post-brand-yellow);
  --paf-toggle-radio-border-color: var(--paf-global-post-brand-secondary);
  --paf-toggle-radio-border-color-selected: var(--paf-global-post-brand-yellow);
  --paf-toggle-radio-border-color-focus: var(--paf-global-post-brand-black);
  --paf-toggle-radio-border-width: var(--paf-global-border-width-2x);
  --paf-toggle-radio-border-radius: 3;
  --paf-toggle-text-color: var(--paf-global-post-brand-dark);
  --paf-toggle-text-color-selected: var(--paf-global-post-brand-black);
  --paf-toggle-transition-duration: 180ms;
  --paf-toggle-font-size-s: 12;
  --paf-toggle-font-size-m: 14;
  --paf-toggle-padding-inline: 7;
  --paf-toggle-padding-block-s: 12;
  --paf-toggle-padding-block-m: 27;
  --paf-toggle-min-height: 72;
}

.toggle-radio {
  @include reset-fieldset;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  border-radius: px-to-rem(var(--paf-toggle-radio-border-radius));

  & .legend {
    @include screen-reader-only;

    display: block;
  }

  & .label {
    position: relative;
    z-index: inherit;
    background-color: var(--paf-toggle-radio-background-color);
    color: var(--paf-toggle-text-color);
    font-size: px-to-rem(var(--paf-toggle-font-size-s));
    line-height: 1;
    text-align: center;
    padding-block: px-to-rem(var(--paf-toggle-padding-block-s));
    padding-inline: px-to-rem(var(--paf-toggle-padding-inline));
    flex-basis: 50%;
    user-select: none;
    border: px-to-rem(var(--paf-toggle-radio-border-width)) solid var(--paf-toggle-radio-border-color);
    transition-duration: var(--paf-toggle-transition-duration);
    transition-property: color, background-color, border-color;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    @include reduced-motion {
      transition: none;
    }

    @include mq($from: medium) {
      min-height: px-to-rem(var(--paf-toggle-min-height));
      padding-block: px-to-rem(var(--paf-toggle-padding-block-m));
      font-size: px-to-rem(var(--paf-toggle-font-size-m));
    }
  }

  & .input {
    position: absolute;
    z-index: 0;
    clip: rect(0, 0, 0, 0);
    height: 0;
    width: 0;

    &:first-of-type + label {
      border-start-start-radius: px-to-rem(var(--paf-global-border-radius-2x));
      border-end-start-radius: px-to-rem(var(--paf-global-border-radius-2x));
    }

    &:last-of-type + label {
      border-start-end-radius: px-to-rem(var(--paf-global-border-radius-2x));
      border-end-end-radius: px-to-rem(var(--paf-global-border-radius-2x));
    }

    &:checked {
      z-index: 1;

      & + .label {
        background-color: var(--paf-toggle-radio-background-color-selected);
        color: var(--paf-toggle-text-color-selected);
        border-color: var(--paf-toggle-radio-border-color-selected);

        @include forced-colors {
          filter: invert(1);
        }
      }
    }

    &:checked:focus-visible,
    &:focus-visible {
      + .label {
        @include focus-box-shadow;
        @include focus-visible;

        z-index: 2;
        flex-basis: calc(50% + px-to-rem(var(--paf-global-border-width-2x)));
        border-radius: px-to-rem(var(--paf-global-spacing-fixed-1x));
      }
    }

    &:first-of-type:checked:focus-visible + .label,
    &:first-of-type:focus-visible + .label {
      margin-inline-end: px-to-rem(calc(var(--paf-global-border-width-2x) * -1));
      padding-inline-end: px-to-rem(calc(var(--paf-toggle-padding-inline) + var(--paf-global-border-width-2x)));
    }

    &:last-of-type:checked:focus-visible + .label,
    &:last-of-type:focus-visible + .label {
      margin-inline-start: px-to-rem(calc(var(--paf-global-border-width-2x) * -1));
      padding-inline-start: px-to-rem(calc(var(--paf-toggle-padding-inline) + var(--paf-global-border-width-2x)));
    }
  }
}
